import { useState, useCallback, useMemo } from "react";
import { EntityModel } from "@jugl-web/rest-api";
import { ManageWorkspaceAdminDialogContext } from "./ManageWorkspaceAdminContext";
import { ManageWorkspaceAdminsDialog } from "./ManageWorkspaceAdminsDialog";

export const ManageWorkspaceAdminProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [entity, setEntity] = useState<EntityModel | null>(null);
  const open = useCallback((entityToLeave?: EntityModel | null) => {
    if (entityToLeave) {
      setEntity(entityToLeave);
    }
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setEntity(null);
    setIsOpen(false);
  }, []);

  const contextValue = useMemo(
    () => ({
      open,
      close,
      isOpen,
    }),
    [open, close, isOpen]
  );

  return (
    <ManageWorkspaceAdminDialogContext.Provider value={contextValue}>
      <ManageWorkspaceAdminsDialog
        isOpen={isOpen}
        onDelete={() => {
          close();
        }}
        onClose={close}
        entityIds={entity ? [entity.id] : undefined}
      />
      {children}
    </ManageWorkspaceAdminDialogContext.Provider>
  );
};
